import React from 'react';
import { Segment, Grid, Icon, Input, Table, Button } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import moment from 'moment';

const UserSearchComponent = ({
  users,
  resultMessage,
  onSearchChange,
  onClickOfDelete,
  onClickOfSearch
}) => (
  <Grid centered style={{ marginTop: '0px', padding: '10vh' }}>
    <Helmet>
      <title>Search User Details</title>
    </Helmet>
    <Grid.Row centered>
      <Grid.Column width={4} textAlign="center">
        <h2
          style={{
            fontWeight: 400,
            border: '1px solid #555',
            textAlign: 'center',
            color: '#555',
            padding: '0.5em'
          }}
        >
          Search User Details
        </h2>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={15}>
        <Segment stacked textAlign="center">
          <Grid>
            <Grid.Row centered>
              <Grid.Column textAlign="center" width={13}>
                <Input
                  fluid
                  icon
                  placeholder="Type full name/mobile no. here..."
                  onChange={onSearchChange}
                  onKeyDown={onClickOfSearch}
                />
              </Grid.Column>
              <Grid.Column textAlign="center" width={3}>
                <Button
                  basic
                  color="blue"
                  fluid
                  data-actiontype="onClickOfSearch"
                  onClick={onClickOfSearch}
                  disabled={users.loading}
                >
                  Search
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          {users.loading ? (
            <Grid>
              <Grid.Row>
                <Grid.Column>
                  <Segment style={{ height: '90vh' }} loading={users.loading} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          ) : null}
          { resultMessage ?
            <span><br />{resultMessage}</span> : null
          }
          {users.list.length ? (
            <React.Fragment>
              <br />
              <Table celled fixed>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>No.</Table.HeaderCell>
                    <Table.HeaderCell>User Id</Table.HeaderCell>
                    <Table.HeaderCell>Mobile</Table.HeaderCell>
                    <Table.HeaderCell>Full Name</Table.HeaderCell>
                    <Table.HeaderCell>Role</Table.HeaderCell>
                    <Table.HeaderCell>Email</Table.HeaderCell>
                    <Table.HeaderCell>Status</Table.HeaderCell>
                    <Table.HeaderCell>Last Login</Table.HeaderCell>
                    <Table.HeaderCell>Join Date</Table.HeaderCell>
                    <Table.HeaderCell>Actions</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {
                    users.list.map((el, index) => (
                      <Table.Row key={el.id}>
                        <Table.Cell>{index + 1}</Table.Cell>
                        <Table.Cell>{el.id}</Table.Cell>
                        <Table.Cell>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <Link
                            // to={`/users/details/${el.id}`}
                            to="#"
                            style={{
                            textDecoration: 'underline',
                            color: '#603cba'
                            }}
                          >
                            {el.mobile}
                          </Link>
                        </Table.Cell>
                        <Table.Cell>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <Link
                            // to={`/users/details/${el.id}`}
                            to="#"
                            style={{
                            textDecoration: 'underline',
                            color: '#603cba'
                            }}
                          >
                            {el.full_name}
                          </Link>
                        </Table.Cell>
                        <Table.Cell>{el.user_role || 'N/A'}</Table.Cell>
                        <Table.Cell>{el.email || 'N/A'}</Table.Cell>
                        <Table.Cell>{el.status}</Table.Cell>
                        <Table.Cell>
                          {el.last_login
                            ? moment
                                .utc(el.last_login)
                                .local()
                                .format('DD-MM-YYYY HH:mm:ss')
                            : 'N/A'}
                        </Table.Cell>
                        <Table.Cell>
                          {/* {new Date(el.created_at).toLocaleString()} */}
                          {moment
                            .utc(el.since)
                            .local()
                            .format('DD-MM-YYYY')}
                        </Table.Cell>
                        <Table.Cell>
                          <Button disabled basic icon color="blue">
                            <Icon name="pencil" />
                          </Button>
                          <Button
                            onClick={() => onClickOfDelete(el.full_name, el.id)}
                            basic
                            icon
                            color="red"
                          >
                            <Icon name="delete" />
                          </Button>
                        </Table.Cell>
                      </Table.Row>
                        ))
                    }
                </Table.Body>
              </Table>
            </React.Fragment>
          ) : null}
        </Segment>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default UserSearchComponent;



// WEBPACK FOOTER //
// ./src/Modules/UserSearch/component.jsx